export default __webpack_public_path__ + "static/media/kylie.4c336027.jpg";